import { ALL_TOUR_TYPES } from '../constants';

export const getListOfAvailableTourTypesForUI = avlTourTypesFromAPI => {
  return ALL_TOUR_TYPES.filter(tourType =>
    avlTourTypesFromAPI.includes(tourType.value)
  );
};
